import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { EquipmentItemDetailSearchSchema } from '../../-zod-schema';

export const Route = createFileRoute(
  '/_staff/equipment/items/$id/_detail/inventory/',
)({
  validateSearch: zodValidator(EquipmentItemDetailSearchSchema),
});
